import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {CoreSidebarService} from "../../../@core/components/core-sidebar/core-sidebar.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {BlogService} from "../../shared/services/blog.service";
import {AlertService} from "../../shared/services/alert.service";
import {CausesService} from "../../shared/services/causes.service";

@Component({
  selector: 'app-causes',
  templateUrl: './causes.component.html',
  styleUrls: ['./causes.component.scss']
})
export class CausesComponent implements OnInit {

  showSearch = false;
  id: any;
  data: any;
  submitted: any = false;
  submitting: any = false;
  searchForm: FormGroup;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };
  blogs = [];
 caueses =[];
  onFileChanged: any;
  viewContentData: any;

  constructor(private router: Router,
              private _coreSidebarService: CoreSidebarService,
              public modalService: NgbModal,
              private fb: FormBuilder,
              private blogService: BlogService,
              private causeService: CausesService,
              private alertService: AlertService) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  toggleSidebar(): void {
    this._coreSidebarService.getSidebarRegistry('add-causes').toggleOpen();
  }

  edit(data) {
    this.data = data;
    this.toggleSidebar();
  }

  add(): void {
    this.data = undefined;
    this.toggleSidebar();
  }

  refresh() {
    this.get();
  }


  getData(valueSubmit: any): void {
    if (valueSubmit) {
      this.get({page: 1, total: null, perpage: 15, pages: null});
      this.toggleSidebar();
    }
  }

  search() {
    const params = {
      'heading': (this.searchForm.value && this.searchForm.value.heading) ? this.searchForm.value.heading : ''
    };
    this.get(params);
  }

  onPageChange(page) {
    this.pagination.page = page;
    const params = {
      heading: (this.searchForm && this.searchForm.value && this.searchForm.value.heading) ? this.searchForm.value.heading : ''
    };
    this.get(params);
  }



  get(params: any = {}) {
    params.page = this.pagination.page;
    params.per_page = this.pagination.perpage;
    this.submitting = true;
    this.caueses = [];
    this.causeService.get(params).subscribe(data => {
      console.log(data['data']);
      if (data && data['data'].length > 0) {
        this.caueses = data['data'];
        this.pagination = {
          page: data.current_page,
          total: data.total,
          perpage: data.per_page,
          pages: data.last_page,
        };
      } else {
        this.caueses = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  blogsInfoPage(data: any) {
    this.router.navigateByUrl('event-info/' + data.id);
  }
  delete(id) {
    this.causeService.delete(id).subscribe(data => {
      this.get();
    });
  }
  onFileChange(e, type, data) {
    this.onFileChanged = e;
    this.causeService.fileUploadAdmin({
      'type': type,
      'fileType': 'NORMAL',
      'insight_id': data.id
    }, this.onFileChanged).subscribe(data => {
      if (type === 'CAUSE_BANNER') {
        if (data && data['data']) {
          this.get();
        }
      }
      this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
    }, error => {
      this.alertService.showErrors('Something went wrong, please try again');
    });
  }

  openBlogBanner(data) {
    console.log(data);
    window.open(data['cause_banner']['url'], '_blank');
  }

  viewContent(content, data) {
    this.viewContentData = data;
    this.modalService.open(content);
  }
  updateStatus(data, status) {
    this.causeService.updateStatus(data.id, {'status': status}).subscribe(data => {
      this.submitting = false;
      this.submitted = false;
      this.get();
    }, error => {
      this.submitting = false;
      this.submitted = false;
    });
  }

}
